import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';
import { ContentRoute, LayoutSplashScreen } from '../../../_metronic/layout';
import { ChallengesPage } from './pages/ChallengesPage';

const Challenges = () => {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<ContentRoute path='/challenges' component={ChallengesPage} />
			</Switch>
		</Suspense>
	);
};

export default Challenges;
